module.exports = __webpack_public_path__ + "static/media/dna_fitness-report.976c4849.png";